import Notification from "../../../components/Common/Notification/index";
import * as shirtOrderApi from "../../../services/shirtOrder";
import {
  ADD_SHIRT_ORDER_FAILURE,
  ADD_SHIRT_ORDER_REQUEST,
  ADD_SHIRT_ORDER_SUCCESS,
  DELETE_SHIRT_ORDER_FAILURE,
  DELETE_SHIRT_ORDER_REQUEST,
  DELETE_SHIRT_ORDER_SUCCESS,
  GET_SHIRT_ORDERS_FAILURE,
  GET_SHIRT_ORDERS_REQUEST,
  GET_SHIRT_ORDERS_SUCCESS,
  GET_SINGLE_SHIRT_ORDER_FAILURE,
  GET_SINGLE_SHIRT_ORDER_REQUEST,
  GET_SINGLE_SHIRT_ORDER_SUCCESS,
  UPDATE_SHIRT_ORDER_FAILURE,
  UPDATE_SHIRT_ORDER_REQUEST,
  UPDATE_SHIRT_ORDER_SUCCESS,
} from "./shirtOrder.actionType"

export const requestAddShirtOrder = () => {
  return {
    type: ADD_SHIRT_ORDER_REQUEST,
  };
};

export const addShirtOrderSuccess = (data) => {
  return {
    type: ADD_SHIRT_ORDER_SUCCESS,
    data,
  };
};

export const addShirtOrderFailure = (message) => {
  return {
    type: ADD_SHIRT_ORDER_FAILURE,
    message,
  };
};

export const addShirtOrder = (data) => {
  return (dispatch) => {
    dispatch(requestAddShirtOrder());
    return shirtOrderApi
      .addShirtOrder(data)
      .then((resp) => {
        const data = resp.data;
        dispatch(addShirtOrderSuccess(data));
        return Notification(
          "",
          `ऑर्डर नोंद केली`,
          "success"
        );
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(addShirtOrderFailure());
        Notification("", errorMessage, "error");
        throw errorMessage;
      });
  };
};

export const requestGetShirtOrders = () => {
  return {
    type: GET_SHIRT_ORDERS_REQUEST,
  };
};

export const getShirtOrdersSuccess = (data) => {
  return {
    type: GET_SHIRT_ORDERS_SUCCESS,
    data,
  };
};

export const getShirtOrdersFailure = (message) => {
  return {
    type: GET_SHIRT_ORDERS_FAILURE,
    message,
  };
};

export const getShirtOrders = () => {
  return (dispatch) => {
    dispatch(requestGetShirtOrders());
    return shirtOrderApi
      .getShirtOrders()
      .then(async (resp) => {
        const data = resp.data;
        await dispatch(getShirtOrdersSuccess(data));
        return data;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(getShirtOrdersFailure());
        if (errorMessage === "Invalid token.") {
          return Notification("आपला सांकेतिक माहिती चुकली आहे ", "", "error");
        }
        Notification("", errorMessage, "error");
      });
  };
};

export const requestgetSingleShirtOrder = () => {
  return {
    type: GET_SINGLE_SHIRT_ORDER_REQUEST,
  };
};

export const getSingleShirtOrderSuccess = (data) => {
  return {
    type: GET_SINGLE_SHIRT_ORDER_SUCCESS,
    data,
  };
};

export const getSingleShirtOrderFailure = (message) => {
  return {
    type: GET_SINGLE_SHIRT_ORDER_FAILURE,
    message,
  };
};

export const getSingleShirtOrder = (id) => {
  return (dispatch) => {
    dispatch(requestgetSingleShirtOrder());
    return shirtOrderApi
      .getSingleShirtOrder(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(getSingleShirtOrderSuccess(data));
        return;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data;
        dispatch(getSingleShirtOrderFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestDeleteShirtOrder = () => {
  return {
    type: DELETE_SHIRT_ORDER_REQUEST,
  };
};

export const deleteShirtOrderSuccess = (data) => {
  return {
    type: DELETE_SHIRT_ORDER_SUCCESS,
    data,
  };
};

export const deleteShirtOrderFailure = (message) => {
  return {
    type: DELETE_SHIRT_ORDER_FAILURE,
    message,
  };
};

export const deleteShirtOrder = (id) => {
  return (dispatch) => {
    dispatch(requestDeleteShirtOrder());
    return shirtOrderApi
      .deleteShirtOrder(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(deleteShirtOrderSuccess(data));
        return Notification(data?.name, `यशस्वीरित्या हटविले गेले.`, "success");
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(deleteShirtOrderFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestUpdateShirtOrder = () => {
  return {
    type: UPDATE_SHIRT_ORDER_REQUEST,
  };
};

export const updateShirtOrderSuccess = (data) => {
  return {
    type: UPDATE_SHIRT_ORDER_SUCCESS,
    data,
  };
};

export const updateShirtOrderFailure = (message) => {
  return {
    type: UPDATE_SHIRT_ORDER_FAILURE,
    message,
  };
};

export const updateShirtOrder = (id, data) => {
  return (dispatch) => {
    dispatch(requestUpdateShirtOrder());
    return shirtOrderApi
      .updateShirtOrder(id, data)
      .then((resp) => {
        const data = resp.data;
        dispatch(updateShirtOrderSuccess(data));
        return true
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(updateShirtOrderFailure());
        Notification("", errorMessage, "error");
      });
  };
};
